/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { isDev } from "constants/domain"
import { storageHelper } from "utils/storage"
import { FeatureFlag } from "./features"

export const Config = {
  maxLengthItemName: 80,
  maxLengthItemDescription: 300,
  maxLengthMartItemDescription: 2000,
  maxLengthCategoryName: 60,
  maxLengthSectionName: 30,
  maxLengthModifierGroupName: 50,
  maxLengthModifierName: 40, // Update this into the same as BE and keep monitoring for the long-term fix.
  maxLengthItemCode: 100,
  maxLengthSkuID: 20,
  maxLengthMenuGroupName: 200,
  maxLengthBulkUploadFileName: 200,
  maxLengthBulkUploadFileSize: 200 * 1024 * 1024, // 200mb
  enableMultipleItemPhoto: false,
  enableDraggableList: isDev(), // TODO: set to true once drag integrated
  enableTableMenuButton: true,
  enableInventory: storageHelper.isFeatureEnabled(
    FeatureFlag.hasAccessInventory,
  ),
  enableOrderManager: storageHelper.isFeatureEnabled(
    FeatureFlag.hasAccessOrderManager,
  ),
  disableNameUniquenessOnCategory: storageHelper.isFeatureEnabled(
    FeatureFlag.disableNameUniquenessOnCategory,
  ),
  enableSellingTime: isDev(),
  hasAccessFeedback: storageHelper.isFeatureEnabled(
    FeatureFlag.hasAccessFeedback,
  ),
  enableMenuTranslation: storageHelper.isFeatureEnabled(
    FeatureFlag.enableMenuTranslation,
  ),
  enableFeedbackDownloadReviews: storageHelper.isFeatureEnabled(
    FeatureFlag.enableFeedbackDownloadReviews,
  ),
  enableItemPhotoCoverage: storageHelper.isFeatureEnabled(
    FeatureFlag.enableItemPhotoCoverage,
  ),
  enableSideNavSettingIcon: storageHelper.isFeatureEnabled(
    FeatureFlag.hasAccessSideNavSetting,
  ),
}
